import React from 'react';

const JS_Scopes = () => {
  return (
    <div >
      <h1>JS_Scopes</h1>
      <p>Placeholder component for: "JS Scopes"</p>
    </div>
  );
};

export default JS_Scopes;
